import React from "react";
import EditProperties from "./EditProperties";

const FieldMenu = ({
  sectionId,
  fieldId,
  field,
  handleUpdateFieldLabel,
  handleUpdateFieldProperty,
  onClose,
  formId,
}) => {
  if (!field) return null;

  return (
    <EditProperties
      sectionId={sectionId}
      fieldId={fieldId}
      field={field}
      handleUpdateFieldLabel={handleUpdateFieldLabel}
      handleUpdateFieldProperty={handleUpdateFieldProperty}
      onClose={onClose}
      formId={formId}
    />
  );
};

export default FieldMenu;
